import Signature from "./Signature";

export default class User {
    constructor(dto) {
        this.id = -1;
        this.name = "";
        this.surname = "";
        this.mobileNumber = "";
        this.organizationId = null;
        this.login = "";
        this.password = "";
        this.accountType = 2;
        this.email = "";
        this.enable2FA = false;
        this.enable2FAOnlyDocECM = false;
        this.languageId = null;
        this.timeZoneId = null;
        this.metricDateFormat = null;
        this.metricDecimalSep = null;
        this.metricThousandSep = null;
        this.privateDashboard = false;
        this.allowImportDashboard = true;
        this.canEditDashboard = false;
        this.signatureImage = null;
        this.signatureCertificateFileName = "";
        this.signatureCertificateBase64 = "";
        this.signatures = [];
        this.swissIDAccountID = "";
        this.sysLevel = "";

        if (dto) {
            this.id = dto.Id;
            this.name = dto.Name;
            this.surname = dto.Surname;
            this.mobileNumber = dto.MobileNumber;
            this.organizationId = dto.OrganizationID != null ? dto.OrganizationID + "" : null;
            this.login = dto.Login;
            this.password = dto.Password;
            this.accountType = dto.AccountType;
            this.email = dto.Email;
            this.enable2FA = dto.EnableTwoFactorAuthentication;
            this.enable2FAOnlyDocECM = dto.EnableTwoFactorAuthenticationOnlyDocECM;
            this.languageId = dto.LanguageID + "";
            this.timeZoneId = dto.TimeZoneID + "";
            this.metricDateFormat = dto.MetricDateFormat;
            this.metricDecimalSep = dto.MetricDecimalSep;
            this.metricThousandSep = dto.MetricThousandSep;
            this.privateDashboard = dto.PrivateDashboard;
            this.allowImportDashboard = dto.AllowImportDashboard;
            this.canEditDashboard = dto.CanEditDashboard;
            this.signatureCertificateFileName = dto.SignatureCertificatePath;
            this.signatures = dto.Signatures ? dto.Signatures.map(function (dto) { return new Signature(dto) }) : [];
            this.swissIDAccountID = dto.SwissIDAccountID;
            this.sysLevel = dto.SysLevel;
        }
    }

    toDto() {
        return {
            Id: this.id,
            Name: this.name,
            Surname: this.surname,
            MobileNumber: this.mobileNumber,
            OrganizationID: this.organizationId,
            Login: this.login,
            Password: this.password,
            AccountType: this.accountType,
            Email: this.email,
            EnableTwoFactorAuthentication: this.enable2FA,
            EnableTwoFactorAuthenticationOnlyDocECM: this.enable2FAOnlyDocECM,
            LanguageID: this.languageId,
            TimeZoneID: this.timeZoneId,
            MetricDateFormat: this.metricDateFormat,
            MetricDecimalSep: this.metricDecimalSep,
            MetricThousandSep: this.metricThousandSep,
            PrivateDashboard: this.privateDashboard,
            AllowImportDashboard: this.allowImportDashboard,
            CanEditDashboard: this.canEditDashboard,
            SignatureCertificate: {
                FileName: this.signatureCertificateFileName,
                Base64File: this.signatureCertificateBase64,
            },
            Signatures: this.signatures.map(p => p.toDto()),
            SwissIDAccountID: this.swissIDAccountID,
            SysLevel: this.sysLevel
        }
    }
}